import type { FC } from 'react';

import s from './WithdrawalErrorBlock.scss';

export interface Props {
  /** Error message to display */
  message: string;
}

const WithdrawalErrorBlock: FC<Props> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={s['error-block']}>
      <div className={s['error-text']}>{message}</div>
    </div>
  );
};

WithdrawalErrorBlock.displayName = 'WithdrawalErrorBlock';

export default WithdrawalErrorBlock;
